<template>
<div class="chapter">
<div class="inner_page">
<p class="p10"><span class="t14">Never be afraid to take a leap of faith.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006.vue?a54fc156